









import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { createPopper, beforeWrite } from '@popperjs/core';
import type { Placement } from '@popperjs/core';

@Component({
  name: 'BasePopper',
})
export default class BasePopper extends Vue {
  @Prop({ default: 'span' }) tagName: string;
  @Prop({ default: false }) appendToBody: boolean;
  @Prop() appendTo: string;
  @Prop({ default: 'top' }) placement: Placement;
  @Prop({ default: () => [0, 0] }) offset: [number, number];
  @Prop({ required: true }) show!: boolean;
  @Prop({ default: false }) sameWidthAsRef: boolean;

  reference;
  popperRef;
  popperElement;
  popper;

  @Watch('show')
  @Watch('placement')
  @Watch('offset')
  async handleWatchShow() {
    await this.popper.setOptions({ placement: this.placement, modifiers: this.modifiers });
  }

  mounted() {
    this.reference = (<HTMLElement>this.$refs['popper-button']).children[0];
    this.popperRef = this.$refs['popper-wrapper'];
    this.popperElement = this.$slots.default?.[0]?.elm;

    if (this.appendToBody) {
      document.querySelector('body').appendChild(this.popperRef);
    } else if (this.appendTo) {
      document.querySelector(this.appendTo).appendChild(this.popperRef);
    }
    if (this.reference && this.popperElement) {
      this.popper = createPopper(this.reference, this.popperElement, {
        placement: this.placement,
        modifiers: this.modifiers,
      });
    }
  }

  get modifiers() {
    return [
      {
        name: 'preventOverflow',
        options: {
          boundary: document.body,
        },
      },
      {
        name: 'offset',
        options: {
          offset: this.offset,
        },
      },
      {
        name: 'sameWidth',
        enabled: this.sameWidthAsRef,
        requires: ['computeStyles'],
        phase: beforeWrite,
        fn: ({ state }) => {
          state.styles.popper.width = `${state.rects.reference.width}px`;
        },
        effect: ({ state }) => {
          state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`;
        },
      },
    ];
  }

  beforeDestroy() {
    if (this.popper) {
      this.popper.destroy();
    }

    if (!this.appendToBody && !this.appendTo) {
      return;
    }

    const popperParent = this.appendToBody ? document.body : document.querySelector(this.appendTo);

    if (popperParent.contains(this.popperRef)) {
      popperParent.removeChild(this.popperRef);
    }
  }
}
